/* import external modules */
import styled from 'styled-components'

export const ButtonContainer = styled.div`
  display: flex;
  margin: 30px auto 15px auto;
  width: max-content;
`
